import React, { FC } from "react"

import { Button, Card, Stack, Text, Title, useMantineTheme } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks"
import { IconRefresh } from "@tabler/icons-react"
import { useLanguage } from "../../contexts/language-context"

type ErrorBoundaryCardProps = {
    title?: string
    text?: string
    withButton?: boolean
}

const ErrorBoundaryCard: FC<ErrorBoundaryCardProps> = ({ title, text, withButton = true }) => {
    const theme = useMantineTheme()
    const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs}px)`)
    const { L } = useLanguage()

    return (
        <Card sx={theme => ({ border: `1px solid ${theme.colors.red[4]}` })}>
            <Stack p={mobile ? "xs" : "xl"} px={mobile ? 0 : "4rem"} align="center" justify="center">
                <Title order={3}>{title ?? L("Oops, something went wrong")}</Title>
                <Text>
                    {text ??
                        L(
                            "We're sorry, but it seems like there was an unexpected error while loading this page. Don't worry, our team has been notified and we're working to fix this issue. Please click the 'Try again' button below or try again later.",
                        )}
                </Text>
                {withButton && (
                    <Button
                        variant="outline"
                        leftIcon={<IconRefresh size={18} />}
                        onClick={() => window.location.reload()}
                    >
                        Try again
                    </Button>
                )}
            </Stack>
        </Card>
    )
}

export default ErrorBoundaryCard
